const resolveHttpClientError = (error) => {
  if (!error.response) {
    return error;
  }

  return error.response.data || error;
};

export default resolveHttpClientError;
